import React, { useEffect, useState } from 'react';
import { AuthContext } from './context/index';
import AppRouter from './components/AppRouter';
import { Provider } from 'react-redux';
import { store } from './redux';
import { Box, CircularProgress } from '@mui/material';

function App() {
  const [isAuth, setIsAuth] = useState<null | boolean>(null);

  useEffect(() => {
    const status = localStorage.getItem('auth')
    if (status === 'true') {
      setIsAuth(true);
    } else {
      setIsAuth(false);
    }
  }, []);

  if (isAuth === null) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <CircularProgress size={60} />
      </Box>
    );
  }

  return (
    <Provider store={store}>
      <AuthContext.Provider value={{
        isAuth,
        setIsAuth
      }}>
        <AppRouter />
      </AuthContext.Provider>
    </Provider>

  );
}

export default App;